const action = "MODEL_EDIT";
export const REQUEST = action+'_REQUEST';
export const RESPONSE = action+'_RESPONSE';
export const FAILURE = action+'_FAILURE';
export const CLEAR = action+'_CLEAR';

export const editModelRequest = (modelId, payload) => {
    return {
        type: REQUEST,
        modelId,
        payload
    };
};

export const editModelSuccess = (response) => ({
  type: RESPONSE,
  payload: response
});

export const editModelFailure = (error) => ({
  type: FAILURE,
  payload: error
});

export const clearState = () => ({
  type: CLEAR
}); 